module.exports = __webpack_public_path__ + "assets/img/legal_card.78ea069a.png";